import { useTranslation } from "react-i18next";
import { GuidanceCallout } from "../../../../components/atoms/atom";
import PermissionPresetSelector from "../../../../components/project/PermissionPresetSelector";
import PermissionsForm from "../../_shared/permissions-form";

function Step2Permissions({
	projectId,
	permissions,
	onPermissionsChange,
	selectedPresetId,
	onPresetApplied,
}) {
	const { t } = useTranslation();

	return (
		<div className="add-member-wizard__step2">
			<GuidanceCallout
				variant="info"
				message={t("projects.members.wizard-step2-hint")}
			/>

			<PermissionPresetSelector
				projectId={projectId}
				value={selectedPresetId}
				labelKey="projects.members.role"
				appliedPermissions={permissions}
				onPresetApplied={({ preset }) => onPresetApplied(preset)}
			/>

			<PermissionsForm
				projectId={projectId}
				permissions={permissions}
				onChange={onPermissionsChange}
				disabled={!permissions}
			/>
		</div>
	);
}

export default Step2Permissions;
